import { RBItem } from "@/interfaces/CardItem";

export function sortCards(a: RBItem, b: RBItem) {
  // cost
  if (b.cost !== a.cost) {
    let acost;
    let bcost;
    if (b.cost === undefined || b.cost === null) {
      bcost = 0;
    } else {
      bcost = b.cost;
    }
    if (a.cost === undefined || a.cost === null) {
      acost = 0;
    } else {
      acost = a.cost;
    }
    // handle special cases where cost is "-" or 0
    if (acost - bcost !== 0) {
      return acost - bcost; // Compare as numbers
    }
  }

  // Handle special card types first (legend, battlefield, token, rune)
  const specialTypes = ["legend", "battlefield", "token", "rune"];
  const aIsSpecial = specialTypes.includes(a.card_type);
  const bIsSpecial = specialTypes.includes(b.card_type);

  // If one is special and the other isn't, sort special first
  if (aIsSpecial && !bIsSpecial) {
    return -1;
  }
  if (!aIsSpecial && bIsSpecial) {
    return 1;
  }

  // If both are special, sort by card type
  if (aIsSpecial && bIsSpecial) {
    const typeOrder: string[] = ["legend", "rune", "battlefield", "token"];

    // Handle special card types for sorting
    const getSortType = (cardType: string) => {
      switch (cardType) {
        case "token unit":
          return "token";
        default:
          return cardType;
      }
    };

    const aType = getSortType(a.card_type);
    const bType = getSortType(b.card_type);

    const typeAIndex = typeOrder.indexOf(aType);
    const typeBIndex = typeOrder.indexOf(bType);

    // If both are the same special type, handle legends specially
    if (typeAIndex === typeBIndex && aType === "legend") {
      // For legends, sort by color first
      if (a.color !== b.color) {
        const colorOrder: string[] = [
          "red",
          "red/green",
          "red/blue",
          "red/orange",
          "red/purple",
          "red/yellow",
          "green",
          "green/blue",
          "green/orange",
          "green/purple",
          "green/yellow",
          "blue",
          "blue/orange",
          "blue/purple",
          "blue/yellow",
          "orange",
          "orange/yellow",
          "orange/purple",
          "purple",
          "purple/yellow",
          "yellow",
        ];
        const colorAIndex = colorOrder.indexOf(a.color);
        const colorBIndex = colorOrder.indexOf(b.color);
        return colorAIndex - colorBIndex;
      }
      // If same color, sort by name
      return a.name.localeCompare(b.name);
    }

    return typeAIndex - typeBIndex;
  }

  // For regular cards (unit, spell, gear), group by color first
  if (b.color !== a.color) {
    const colorOrder: string[] = [
      "red",
      "red/green",
      "red/blue",
      "red/orange",
      "red/purple",
      "red/yellow",
      "green",
      "green/blue",
      "green/orange",
      "green/purple",
      "green/yellow",
      "blue",
      "blue/orange",
      "blue/purple",
      "blue/yellow",
      "orange",
      "orange/yellow",
      "orange/purple",
      "purple",
      "purple/yellow",
      "yellow",
    ];
    const colorAIndex = colorOrder.indexOf(a.color);
    const colorBIndex = colorOrder.indexOf(b.color);
    return colorAIndex - colorBIndex;
  }

  // Then by card type for regular cards
  if (b.card_type !== a.card_type) {
    const typeOrder: string[] = ["unit", "spell", "gear"];

    // Handle special card types for sorting
    const getSortType = (cardType: string) => {
      switch (cardType) {
        case "champion unit":
        case "signature unit":
          return "unit";
        case "signature spell":
          return "spell";
        default:
          return cardType;
      }
    };

    const aType = getSortType(a.card_type);
    const bType = getSortType(b.card_type);

    const typeAIndex = typeOrder.indexOf(aType);
    const typeBIndex = typeOrder.indexOf(bType);
    return typeAIndex - typeBIndex;
  }

  // recycle_cost (power_cost) (ascending)
  if (b.power_cost !== a.power_cost) {
    let aPowerCost = a.power_cost || 0;
    let bPowerCost = b.power_cost || 0;
    return aPowerCost - bPowerCost;
  }

  // rarity
  // make P2 appear after P1 etc.

  // power (ascending)
  if (b.might !== undefined && a.might !== undefined && b.might !== a.might) {
    let amight, bmight;
    if (a.might === undefined) {
      amight = 0;
    } else {
      amight = a.might;
    }
    if (b.might === undefined) {
      bmight = 0;
    } else {
      bmight = b.might;
    }
    return amight - bmight;
  }

  return a.name.localeCompare(b.name);
}
